<template>
    <!-- <div class="relative group inline-flex">
        <QuestionMarkCircleIcon class="h-5 w-5 text-blue-600" />
        <p
            class="bg-blue-100 text-blue-500 font-medium text-sm w-[500px] invisible transition-opacity duration-500 ease-in-out opacity-0 left-5 -top-4 group-hover:opacity-100 group-hover:visible absolute p-4 rounded-md">
            {{ tooltip }}</p>
    </div> -->
    <div class="inline-flex">
        <div ref="referenceRef" class="inline-flex" @blur="hide" @focus="show" @mouseenter="show" @mouseleave="hide">
            <QuestionMarkCircleIcon class="h-5 w-5 text-blue-600" />
        </div>
        <div ref="floatingRef" :class="[
            'absolute top-0 left-0 z-50 bg-gray-700 text-sm text-white px-3 py-1.5 rounded-md cursor-default',
            isHidden && 'hidden',
        ]">
            {{ tooltip }}
            <div ref="arrowRef" class="absolute bg-gray-700 h-[8px] w-[8px] rotate-45"></div>
        </div>
    </div>
</template>

<script setup >
import { ref } from "vue";
import { arrow, computePosition, flip, offset, shift } from "@floating-ui/dom";
import { QuestionMarkCircleIcon } from '@heroicons/vue/20/solid'

const props = defineProps({
    tooltip: {
        type: String,
        required: false
    }
})


const referenceRef = ref();
const floatingRef = ref();
const arrowRef = ref();
const isHidden = ref(true);
 

async function calculatePosition() {
    const { x, y, middlewareData, placement } = await computePosition(
        referenceRef.value,
        floatingRef.value,
        {
            placement: props.placement,
            middleware: [
                offset(8),
                flip(),
                shift({ padding: 5 }),
                arrow({ element: arrowRef.value }),
            ],
        }
    );

    Object.assign(floatingRef.value.style, {
        left: `${x}px`,
        top: `${y}px`,
    });

    const { x: arrowX, y: arrowY } = middlewareData.arrow;

    const opposedSide = {
        left: "right",
        right: "left",
        bottom: "top",
        top: "bottom",
    }[placement.split("-")[0]];

    Object.assign(arrowRef.value.style, {
        left: arrowX ? `${arrowX}px` : "",
        top: arrowY ? `${arrowY}px` : "",
        bottom: "",
        right: "",
        [opposedSide]: "-4px",
    });
}

function hide() {
    isHidden.value = true;
}

function show() {
    isHidden.value = false;
    calculatePosition();
}

</script>